export default __webpack_public_path__ + "static/media/approved.41015f7c.png";